/* eslint dot-notation:0 */
(function(angular, _) {
    'use strict';

    angular.module('um.filters').controller('filters.controller', filtersCtrl);

    filtersCtrl.$inject = [
        '$scope', '$state', 'wtNotifications', 'filtersService', 'trackingService', '$translate',
        'rolesService', '$stateParams', '$q'
    ];

    function filtersCtrl($scope, $state, wtNotifications, filtersService, trackingService, $translate,
        rolesService, $stateParams, $q) {
        const that = this;

        this.$onInit = function() {
            const defaultFilter = {
                name: '',
                accountId: '',
                userIds: [],
                specification: {
                    filters: [],
                    containers: []
                }
            };
            const promises = [
                rolesService.getServiceAccounts()
            ];
            if ($stateParams.filterId) {
                promises.push(filtersService.getFilter($stateParams.filterId));
            }

            return $q.all(promises).then(function(values) {
                that.serviceAccounts = _.nth(values, 0) || [];

                if ($stateParams.filterId) {
                    that.filter = _.nth(values, 1) || defaultFilter;

                    // options for account select in details
                    that.selectedAccountKey = that.filter.accountId;
                    that.accountWasSelected = !_.isEmpty(that.selectedAccountKey);
                    // on edit filter get available and selected users
                    that.getUserAllocatorLists();
                } else {
                    that.filter = defaultFilter;
                }

                that.formatServiceAccounts();
                that.accountList = _.filter([].concat(that.accounts), function(el) {
                    return !_.isEmpty(el.accountId);
                });
            });
        };

        that.accountList = [];
        that.accounts = [];
        that.filterReady = null; // TODO does this really work?
        that.liveAnalyticsEnabled = false;
        that.liveElementsProhibited = false;

        const filterReadyWatch = $scope.$watch(() => that.filterReady, function(newFilterReady, oldFilterReady) {
            if (newFilterReady === true && newFilterReady !== oldFilterReady) {
                filtersService.getDimensionsAndMetrics()
                    .then((frontendConfig) => {
                        that.liveAnalyticsEnabled = !_.chain(frontendConfig).get('live.dimensions').isEmpty().value();
                    });
            }
        });

        const filterWatch = $scope.$watch(() => that.filter, (value) => {
            that.liveElementsProhibited = !filtersService.isCompatibleWithRealTime(value);
        }, true);

        that.accountMapping = {
            key: 'accountId',
            title: 'name',
            active: 'active'
        };

        that.clickHandlers = {
            leftClick: function(index, element) {
                if (element && element.accountId) {
                    that.selectedAccountKey = element.accountId;
                    that.filterReady = false;
                    that.filter.specification.containers = [];
                    that.filter.specification.filters = [];
                    that.accountWasSelected = true;
                    filtersService.setSelectedAccountId(element.accountId);
                    that.getUserAllocatorLists();
                }
            }
        };

        // source and target list user allocator
        that.availableUsers = [];
        that.selectedUsers = [];

        // options user allocator
        that.usersAllocatorOptions = {
            leftListHeading: 'AVAILABLE_USERS',
            rightListHeading: 'ASSIGNED_USERS',
            addButtonText: '',
            removeButtonText: '',
            searchPlaceholder: 'SEARCH',
            orderBy: 'loginName',
            locked: false,
            identifier: 'id',
            filterFunction: function(element, value) {
                // filters the loginName, not taking the companyPrefix into account
                if (!_.isUndefined(element) && _.has(element, 'loginName')) {
                    return Boolean(element.loginName.replace(/^([^.]+)./, '').toLowerCase().match(value.toLowerCase()));
                }
                return false;
            },
            filterBar: {
                target: true,
                source: true
            },
            clickHandlers: {
                remove: null, // set later in the code
                add: null
            },
            decorators: { // remove the company prefix from the loginName
                loginName: function(name) {
                    return name.replace(/^([^.]+)./, '');
                }
            },
            columns: [
                {title: '', key: 'loginName'}
            ],
            hideHeader: true,
            boxDimensions: {
                height: '200px'
            }
        };

        // formats the serviceAccounts list
        that.formatServiceAccounts = function() {
            for (var i = 0; i < that.serviceAccounts.length; i++) {
                if (!_.find(that.accounts, {accountId: that.serviceAccounts[i].account.accountId})) {
                    // don't take the following services in:
                    // - tagintegration (safetag - ST)
                    // - customer journey (AC)
                    // - testing (DVL) -> could be useful as well
                    // TODO: Remove AC & DVL once DB is deployed, should not be in any account anymore!
                    var excludedServices = ['ST', 'AC', 'DVL'];

                    // serviceAccounts[i].enabled -> could be useful as well
                    if (_.findIndex(excludedServices, that.serviceAccounts[i].service.name) < 0) {
                        that.accounts.push({
                            name: that.serviceAccounts[i].account.name,
                            accountId: that.serviceAccounts[i].account.accountId,
                            active: true
                        });
                    }
                }
            }
        };

        that.save = function save() {
            // preparations for saving
            that.filter.accountId = that.selectedAccountKey;
            that.filter.userIds = _.map(that.selectedUsers, 'id'); // only an array of userIds is needed

            if (that.filter.id) { // update existing filter
                trackingService.action('filter.update');
                filtersService.updateFilter(that.filter)
                    .then(function(res) {
                        $state.go('main.filters.overview')
                            .then(() => {
                                wtNotifications.success(
                                    $translate.instant('FILTER_MSG_UPDATE_SUCCESS', {filterName: res.name}, '', '')
                                );
                            });
                    })
                    .catch(function(err) {
                        if (_.has(err, 'message') && !_.isUndefined(err.message)) {
                            wtNotifications.error(err.message.toUpperCase());
                        }
                    });
            } else { // create new filter
                trackingService.action('filter.create');
                filtersService.createFilter(that.filter)
                    .then(function(res) {
                        $state.go('main.filters.overview')
                            .then(() => {
                                wtNotifications.success(
                                    $translate.instant('FILTER_MSG_CREATE_SUCCESS', {filterName: res.name}, '', '')
                                );
                            });
                    })
                    .catch(function(err) {
                        if (_.has(err, 'message') && !_.isUndefined(err.message)) {
                            wtNotifications.error(err.message.toUpperCase());
                        }
                    });
            }
        };

        that.getUserAllocatorLists = function getUserAllocatorLists() {
            return filtersService.getAvailableUsersForAccount(
                that.selectedAccountKey,
                _.has(that.filter, 'id') ? that.filter.id : null
            ).then(function(response) {
                var tempUsers = [];
                if (!_.isEmpty(that.filter.userIds)) {
                    that.filter.userIds.forEach(function(userId) {
                        // search for the previously selected users in currently available users
                        var tmpUser = _.find(response, function(user) {
                            return user.id === userId;
                        });
                        // if the user can't be found, it shall not be added an 'undefined'
                        if (!_.isUndefined(tmpUser)) {
                            tempUsers.push(tmpUser);
                        }
                    });
                }
                that.selectedUsers = tempUsers;
                that.availableUsers = response || [];
            }).catch(function() {
                // TODO notification
            });
        };

        $scope.$on('$destroy', function() {
            filterReadyWatch();
            filterWatch();
        });
    }
})(window.angular, window._);
